import * as Yup from "yup";

export const formValidationSchema = Yup.object().shape({
  tgl_info_peluang: Yup.date().required("Tanggal Peluang wajib diisi"),
  id_customer: Yup.string().required("Customer wajib diisi"),
  id_proyek: Yup.string().required("Proyek wajib diisi"),
  id_nama_marketing: Yup.string().required("Nama marketing wajib diisi"),
});
